export const LinearDeterminateLoading = ({ height = 4, color = "blue", backgroundColor = "gray" }) => {
  const colorClasses = {
    gray: "tw-bg-gray-300",
    green: "tw-bg-green-500",
    purple: "tw-bg-purple-500",
    red: "tw-bg-red-500",
    yellow: "tw-bg-yellow-500",
    indigo: "tw-bg-indigo-500",
    pink: "tw-bg-pink-500",
  };

  const bgColorClasses = {
    gray: "bg-gray-200",
    slate: "bg-slate-200",
    zinc: "bg-zinc-200",
  };

  return (
    <div className={`tw-w-[60%] ${bgColorClasses[backgroundColor] || bgColorClasses.gray} tw-rounded-full tw-overflow-hidden tw-relative`} style={{ height: `${height}px` }}>
      <div
        className={`tw-h-full ${colorClasses[color] || colorClasses.gray} tw-rounded-full tw-absolute tw-top-0 tw-animate-pulse`}
        style={{
          width: "30%",
          animation: "slide 2s infinite ease-in-out",
        }}
      />
      <style>{`
          @keyframes slide {
            0% {
              left: -30%;
              opacity: 0;
            }
            50% {
              opacity: 1;
            }
            100% {
              left: 100%;
              opacity: 0;
            }
          }
        `}</style>
    </div>
  );
};
